export enum ApplicationSections {
	TARIFF,
	DETAILS
}